import styled from 'styled-components';
import { DefaultTheme } from 'styled-components';

interface TypographyProps {
  $variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'body1' | 'body2';
  $gradient?: boolean;
  $align?: 'left' | 'center' | 'right';
  $color?: 'primary' | 'secondary' | 'highlight';
  children: React.ReactNode;
}

const StyledTypography = styled.div<TypographyProps>`
  text-align: ${({ $align }) => $align || 'left'};
  color: ${({ $color, theme }) => 
    $color ? theme.colors.text[$color] : theme.colors.text.primary};
  background: ${({ $gradient, theme }) =>
    $gradient
      ? `linear-gradient(135deg, ${theme.colors.primary.light}, ${theme.colors.primary.main})`
      : 'none'};
  -webkit-background-clip: ${({ $gradient }) => ($gradient ? 'text' : 'none')};
  -webkit-text-fill-color: ${({ $gradient }) => ($gradient ? 'transparent' : 'inherit')};
`;

export const Typography: React.FC<TypographyProps> = (props) => {
  return <StyledTypography {...props} />;
};

// Componentes de conveniência
export const Text = styled(Typography).attrs({ $variant: 'body1' })``;
export const Title = styled(Typography).attrs({ $variant: 'h1', $gradient: true })``; 